













import { createComponent, computed, ref } from "@vue/composition-api";
import ResourceItemPrefetchedInput from "./ResourceItemPrefetchedInput.vue";
import ResourceItemLiveInput from "./ResourceItemLiveInput.vue";
import { ListActions } from "@megarax/client/src/list";
import { Resource } from "@megarax/client/src";
import { ResourceItem } from "@megarax/client/src/resources/ResourceItem";
import { useActions } from "@/shared/useMegaraxClient";
import { DetailActions } from "@megarax/client/src/detail";

interface Props {
  resource: Resource<ListActions<any> & DetailActions<any>>;
  value: any;
  live: boolean;
  filters: object;
  detail: boolean;
  multiple: boolean;
}

export default createComponent<Props>({
  components: {},
  props: {
    resource: { required: true },
    value: { required: true },
    live: { type: Boolean, default: false },
    detail: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    filters: { default: () => ({}) },
  },
  setup(props, ctx) {
    const actions = useActions(props.resource);
    if (props.multiple && props.detail) throw Error("Not implemented");

    const inputComponent = computed(() =>
      props.live ? ResourceItemLiveInput : ResourceItemPrefetchedInput,
    );

    const isLoading = ref(false);

    const onInput = async (val: ResourceItem | null) => {
      if (!props.detail) ctx.emit("input", val);
      else if (!val) {
        ctx.emit("input", null);
      } else {
        isLoading.value = true;
        const detailItem = await actions.fetchItem(val.id!);
        ctx.emit("input", detailItem);
        isLoading.value = false;
      }
    };

    const listeners = {
      ...ctx.listeners,
      input: onInput,
    };

    return {
      isLoading,
      listeners,
      inputComponent,
    };
  },
});
